import React from 'react';
import { Route } from "react-router-dom";
import VisitsList from './visits.list';

const VisitsRouter = ({ match }) => (
  <div>
    <Route path={`${match.path}/:id`} />
    <Route
      exact
      path={match.path}
      render={() => <VisitsList/>}
    />
  </div>
);

export default VisitsRouter;
